/**
 * Youtube module
 *
 * This module is used to replace the youtube iframe with a cookieblock src and a placeholder image. This is to prevent youtube from tracking the user before they have accepted the cookie consent.
 * The module will also add the cookieconsent attribute to the iframe to ensure it is only loaded when the user has accepted the cookie consent.
 *
 */


export default function youtubeInit() {

  const iframeELems = document.getElementsByTagName('iframe');
  const cookieLink  =  ('cookieLink' in window) ? window.cookieLink : null;
  if(iframeELems.length) {
    for (let i = 0; i < iframeELems.length; i++) {
      if(iframeELems[i].src.includes('youtube')) {
        const videoId = iframeELems[i].src.split('embed/')[1].split('?')[0];
        const width = iframeELems[i].getAttribute('width');
        const height = iframeELems[i].getAttribute('height');

        iframeELems[i].setAttribute('data-cookieblock-src', 'https://www.youtube.com/embed/' + videoId);
        iframeELems[i].setAttribute('src', '');
        iframeELems[i].setAttribute('data-cookieconsent', 'marketing, statistics, preferences');

        // Add placeholder image with the same with and height attributes
        iframeELems[i].insertAdjacentHTML('beforebegin', `<div class="cookieconsent-optout-marketing cookieconsent-optout-statistics cookieconsent-optout-preferences"><img src="https://img.youtube.com/vi/${videoId}/hqdefault.jpg"
        width="${width}" height="${height}"
        alt="Youtube video placeholder" />
       <div class="p-3 ">${cookieLink}</div></div>`);
      }
    }
  }
}
